module.exports = __webpack_public_path__ + "img/seo-reporter.efb52c0a.png";